export default {
  hotsiteSlots: (state) => state.hotsiteSlots,
}
